import React from "react";
import {
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
} from "@mui/material";

export default function CityMasterFilters({
  countries,
  states,
  countryId,
  stateId,
  citySearch,
  onCountryChange,
  onStateChange,
  onCitySearchChange,
  onSearch,
  loadingCountries,
  loadingStates,
  loading,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2.5, mb: 2 }}>
      <Stack spacing={2.5}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel id="cm-country" shrink>
                Country
              </InputLabel>
              <Select
                labelId="cm-country"
                label="Country"
                value={countryId}
                onChange={(e) => onCountryChange(e.target.value)}
                disabled={loadingCountries}
                displayEmpty
                notched
              >
                <MenuItem value="all">
                  <em>All</em>
                </MenuItem>
                {countries.map((c) => (
                  <MenuItem key={c.cid} value={String(c.cid)}>
                    {c.country_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel id="cm-state" shrink>
                State
              </InputLabel>
              <Select
                labelId="cm-state"
                label="State"
                value={stateId}
                onChange={(e) => onStateChange(e.target.value)}
                disabled={countryId === "all" || loadingStates}
                displayEmpty
                notched
              >
                <MenuItem value="all">
                  <em>All</em>
                </MenuItem>
                {states.map((s) => (
                  <MenuItem key={s.id} value={String(s.id)}>
                    {s.state}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Divider />
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={8}>
            <TextField
              fullWidth
              size="small"
              label="City search"
              placeholder="Search city name..."
              value={citySearch}
              onChange={(e) => onCitySearchChange(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && onSearch()}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Button variant="contained" onClick={onSearch} disabled={loading} sx={{ minWidth: 120 }}>
              {loading ? <CircularProgress size={22} color="inherit" /> : "Search"}
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </Paper>
  );
}
